import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { PatrolDiscordCockpitService } from '../../../services/patrol-discord-cockpit.service';

@Component({
  selector: 'app-patrol-discord-case-record',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslatePipe],
  templateUrl: './patrol-discord-case-record.component.html',
  styleUrl: './patrol-discord-case-record.component.scss',
})
export class PatrolDiscordCaseRecordComponent {
  #cockpit = inject(PatrolDiscordCockpitService);

  readonly caseSummaries = this.#cockpit.caseSummaries;
  readonly caseRecord = this.#cockpit.caseRecordDetail;
  readonly isLoading = this.#cockpit.isLoadingCases;
  readonly loadError = this.#cockpit.caseRecordError;
  readonly copiedExport = this.#cockpit.copiedCaseExport;

  readonly caseIdQuery = signal('');
  readonly discordUserQuery = signal('');

  formatDate(iso: string): string {
    return this.#cockpit.formatDate(iso);
  }

  shortCaseId(caseId: string): string {
    return caseId.slice(0, 8);
  }

  actionLabel(action: string): string {
    return `app.patrol.discord.cockpit.caseRecord.actions.${action}`;
  }

  async search(): Promise<void> {
    await this.#cockpit.searchCaseRecords({
      caseIdPrefix: this.caseIdQuery(),
      discordUserId: this.discordUserQuery(),
    });
  }

  async openCase(caseId: string): Promise<void> {
    await this.#cockpit.loadCaseRecord(caseId);
  }

  async copyExport(): Promise<void> {
    await this.#cockpit.copyCaseExport();
  }
}
